import ProviderCCSRegistration from './views'

export default ProviderCCSRegistration



// WEBPACK FOOTER //
// ./src/providers-registrations/details/index.js